import { createStyles, makeStyles } from '@material-ui/styles';
import palette from 'theme/palette';
import GiftTexture from 'assets/lots/confettis/confettis.png';

const style = () =>
  createStyles({
    root: {
      borderRadius: palette.borderRadius.default,
      width: '100%',
      background: `#0101FF url(${GiftTexture})`,
      backgroundSize: 'contain',
      overflow: 'hidden',
      position: 'relative'
    },
    content: {
      width: '100%',
      padding: '1rem 1rem 1rem 1rem',
      float: 'right',
      '@media (min-width: 1000px)': {
        width: '75%'
      },
      zIndex: 100
    },
    giftImage: {
      display: 'none',
      position: 'absolute',
      bottom: 0,
      objectFit: 'cover',
      transform: 'translate(5%, 10%)',
      '@media (min-width: 1000px)': {
        display: 'block',
        maxWidth: '40%'
      },
      '@media (min-width: 1500px)': {
        display: 'block',
        maxWidth: '30%'
      }
    },
    time: {
      flex: 1,
      display: 'flex'
    },
    timeText: {
      border: '1px solid white',
      padding: '0.5rem',
      borderRadius: palette.borderRadius.default,
      color: 'white'
    },
    text: {
      flex: 2,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: 'white',
      fontSize: '1rem',
      fontWeight: 'bold',
      marginTop: '0.75rem',
      marginBottom: '0.75rem',
      '@media (min-width: 1200px)': {
        fontSize: '1.5rem'
      }
    },
    title: {
      color: 'white',
      fontSize: '1rem',
      fontWeight: 'bold',
      marginTop: '0.75rem',
      marginBottom: '0.75rem',
      '@media (min-width: 1200px)': {
        fontSize: '1.5rem'
      }
    },
    vente: {
      backgroundColor: '#a57fd9',
      color: 'white',
      border: '2px solid white',
      borderRadius: palette.borderRadius.default,
      textAlign: 'center',
      padding: '1rem',
      fontWeight: 'bold',
      flex: 1
    },
    amount: {
      fontSize: '1.25rem'
    },
    ventesContainer: {
      display: 'flex',
      flexDirection: 'column',
      '@media (min-width: 700px)': {
        flexDirection: 'row'
      },
      gap: '1rem'
    },
    button: {
      flex: 1,
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '0.5rem'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
